"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "camisano": {
    "173d11ac": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "caminetti-di-sotto": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7831808": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-boschetta": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "875bb88b": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "dosso": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "825b9534": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "marchesana": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6856a019": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "marchesanina": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67d8e48e": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "paganine": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7c96938": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "ravezza": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "403c7946": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "rosa": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fbca9b8e": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "salicetto": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4bfdaa36": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "salizza": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d4541e4f": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "san-giacomo": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86833d31": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "torriani": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "49e84f5d": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "skipSearch": false
    }],
    "torrianoni": [{
      "hkey": "d972811c",
      "slug": "camisano",
      "name": "Camisano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;